import React, {Component} from 'react';
import './ProductDetail.css';
import Accordion from "../../Elements/Accordion/Accordion";
import Headline from "../../Elements/Headline/Headline";
import {ajax} from '../../../Context';
import Spinner from "../../Elements/Spinner/Spinner";
import LogoDisclaimer from "../../Elements/LogoDisclaimer/LogoDisclaimer";
import Logo from "../../Elements/Logo/Logo";

const AJAX_TYPE = '135793';

class ProductDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            product: this.props.product,
            data:null
        };

    }

    componentDidMount() {
        fetch(ajax.url + '?type=' + AJAX_TYPE + '&product=' + this.props.product.id + '&uhash=' + this.props.hash)
            .then(response => response.json())
            .then(data => this.setState({data}));
    }



    render() {
        if(this.state.data !== null) {
            var classId = "accordion" + this.state.data.id;
            let accordions;
            if(typeof this.state.data.categories !== 'undefined' && this.state.data.categories.length > 0) {
             accordions = (
                 <div id={classId}>
                     {this.state.data.categories.map(function(accordion,index){
                         return <Accordion height={this.props.height} width={this.props.width} panel={accordion} key={index} container={this.state.data.id} changeRoute={this.props.changeRoute} setFile={this.props.setFile} />
                     }.bind(this))}
                 </div>
             )
            }else{
                accordions = (
                    <span className="hidden">No Documents found</span>
                )
            }
            return <div className="product-details">
                <Headline tag="h1" label={this.state.data.title} brand="default" additionalClassname="product-details--title" />
                <div className="product-details-logo">
                    <Logo url={this.state.product.logoPath}/>
                </div>
                <div className="product-details--description" dangerouslySetInnerHTML={{__html:this.state.data.desc}} />
                <div className="product-details--documents">
                    {accordions}
                </div>
               <LogoDisclaimer disclaimer={this.state.data.disclaimer}/>
            </div>
        }else{
            return <Spinner message="" />;
        }
    }
}

export default ProductDetail;


// WEBPACK FOOTER //
// ./src/Components/Detailview/ProductDetail/ProductDetail.js